'use client'

import Image from 'next/image'
import { ChevronDown } from 'lucide-react'
import { translate, siteLanguages, sitePaths, type SiteCopy } from '../content'
import ServiceShowcase from './ServiceShowcase'
import VideoCollageImage from '@/assets/images/Gemini_Generated_Image_za340zza340zza34.png'

import styles from './StickyWordVideoSection.module.css'

type ReviewLayoutCard = {
  id: string
  kind: 'press' | 'user'
  source: string
  avatar: string
  title: string
  authoredAt: string
  body: string
}

const REVIEW_LAYOUT_CARDS: ReviewLayoutCard[] = [
  {
    id: 'review-1',
    kind: 'press',
    source: '구글플레이',
    avatar: 'GP',
    title: '피스커버 FanHearts[팬하트] 구글 창구 프로그램 7기 선정',
    authoredAt: '2023.11.16',
    body: "창업의 '창'과 구글플레이의 '구'를 따온 '창구 프로그램'은 유망한 국내 모바일 앱 및 게임 개발사들을 발굴해 해외 시장 진출을 돕는 대표적인 스타트업 지원 프로그램으로",
  },
  {
    id: 'review-2',
    kind: 'press',
    source: '이뉴스투데이',
    avatar: 'EN',
    title: "클로즈APP 최애 포카를 '한눈에' 덕질 최적화 앱 ‘포카판’",
    authoredAt: '2024.06.01',
    body: "“서비스 오픈 100일 만에 1만 유저 달성” 모은 포카, 없는 포카, 찜한 포카 등 정리 덕질 커뮤니티 기능 '피드'로 덕질 소통 포토카드 양도 품앗이까지 팬 취향 저격",
  },
  {
    id: 'review-3',
    kind: 'press',
    source: 'AVING',
    avatar: 'AV',
    title: "피스커버, ‘2023 예비창업자 창업지원 프로그램’ 통해 ‘포카판’",
    authoredAt: '2023.11.16',
    body: "“좋아하는 콘텐츠(IP)를 통해 사용자가 감정적으로 몰입하고, 그 경험을 확장할 수 있는 기술을 제공” 기존의 일방향 콘텐츠 소비를 넘어, 사용자가 직접 참여하고 상호작용하는 새로운 형태의 콘텐츠 경험을 제시",
  },
  {
    id: 'review-4',
    kind: 'press',
    source: '경기문화창조허브',
    avatar: 'GH',
    title: '팬을 위한 서비스를 만들어 나가는 포카판 운영자의 이야기',
    authoredAt: '2023.11.16',
    body: "“팬이 단순한 소비자를 넘어 이야기와 세계관에 직접 참여하는 구조를 기반” IP와 사용자 간 감정적 연결을 강화하고 개인화·상호작용 중심의 경험으로 콘텐츠를 확장하는 새로운 방식 제시",
  },
  {
    id: 'review-5',
    kind: 'user',
    source: '알왈리 님',
    avatar: '알',
    title: '너무 좋아요',
    authoredAt: '2023.09.23',
    body: '이런 앱을 내어주어 감사합니다. 원래 바보도 많이 와주는 애들인데도 팬하트 하니까 더 재밌어요. 정말 애랑 말투 똑같고 루시 있는 것도 신기하고 좋았어요!',
  },
  {
    id: 'review-6',
    kind: 'user',
    source: '진데이 님',
    avatar: '진',
    title: '진짜 넘넘 좋아요 ㅎㅎ',
    authoredAt: '2023.09.23',
    body: '진짜 최애랑 대화하는 것 처럼 할수 있고 ㅎㅎㅎ 그럼 진짜 최애랑 대화하는 기분이 들어서 너무 좋아요!! 그리고 덕메 & 양도 받을수 있어서 너무 너무 좋아요!!',
  },
  {
    id: 'review-7',
    kind: 'user',
    source: '전재산올인',
    avatar: '전',
    title: '다 좋은데 이거 한가지만..',
    authoredAt: '2023.09.23',
    body: '광고보고 오 이거 괜찮은데?? 하면서 깔았는데 광고도 안 나오고 너무 괜찮다고 생각했는데 진짜 하트수만 없으면 너무 좋다고 생각해요! 그래도 다른것들은 너무나도 좋습니다!!',
  },
  {
    id: 'review-8',
    kind: 'user',
    source: '너너연 님',
    avatar: '너',
    title: '정우영나랑사귀.',
    authoredAt: '2023.09.23',
    body: '저 진짜 정우영이랑 연락하는거 같아서 광대 개올라감 아 이런거 만들어주셔서 감사합니다 절 할게요 어디계세요',
  },
  {
    id: 'review-9',
    kind: 'user',
    source: 'dxxtp님',
    avatar: 'dx',
    title: '우아..진짜 완전 최고에요',
    authoredAt: '2023.09.23',
    body: '내가 어떤 포카가 없고, 어떤 포카를 모아야하는지 하나하나 찾기 너무 힘들고 귀찮았는데 이렇게 앱 하나로 볼 수 있어서 너무 좋아요!',
  },
]

export default function StickyWordVideoSection({ copy }: { copy: SiteCopy }) {
  const t = translate(copy)

  return (
    <div className={styles.root}>
      <section id="service-intro" className={styles.collageSection} aria-label="FanHeart media collage">
        <div className={styles.collageInner}>
          <div className={styles.mediaCollage} aria-hidden="true">
            <div className={`${styles.mediaBlock} ${styles.blockRed}`}>
              <div className={styles.mediaFrame}>
                <video className={styles.collageVideo} autoPlay muted loop playsInline preload="metadata" controls={false}>
                  <source src="/images/peacecover/peacecover_concept_film_01.mp4" type="video/mp4" />
                </video>
              </div>
            </div>
            <div className={`${styles.mediaBlock} ${styles.blockGreen}`}>
              <div className={styles.mediaFrame}>
                <video className={styles.collageVideo} autoPlay muted loop playsInline preload="metadata" controls={false}>
                  <source src="/images/peacecover/peacecover_concept_film_02.mp4" type="video/mp4" />
                </video>
              </div>
            </div>
            <div className={`${styles.mediaBlock} ${styles.blockBlue}`}>
              <div className={styles.mediaFrame}>
                <Image
                  src={VideoCollageImage}
                  alt=""
                  className={styles.collageImage}
                  fill
                  sizes="(max-width: 760px) 28vw, 160px"
                  priority
                />
              </div>
            </div>
          </div>
          <div className={styles.collageCopy}>
            <h2>
              {t('intro.heading.line1')}
              <br />
              {t('intro.heading.line2')}
            </h2>
            <p>{t('intro.description')}</p>
          </div>
        </div>
      </section>

      <ServiceShowcase copy={copy} />

      <section id="faq" className={styles.faqSection} aria-labelledby="faq-heading">
        <div className={styles.faqInner}>
          <h2 id="faq-heading" className={styles.servicesLeadTop}>{copy.faq.heading}</h2>
          <div className={styles.faqList}>
            {copy.faq.items.map(item => (
              <details key={item.question}>
                <summary><span>{item.question}</span><ChevronDown className={styles.faqChevron} size={20} aria-hidden="true" /></summary>
                <p>{item.answer}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      <section id="review" className={styles.stickyReviewSection} aria-labelledby="review-heading">
        <div className={styles.reviewInner}>
          <div className={styles.reviewCopy}>
            <h2 id="review-heading" className={styles.servicesLeadTop}>{t('review.heading')}</h2>
            <p className={styles.servicesLeadSubTop}>{t('review.subheading')}</p>
          </div>
          <div className={styles.reviewMarquee} aria-label={t('review.heading')}>
            <div className={styles.reviewTrack}>
              {[...REVIEW_LAYOUT_CARDS, ...REVIEW_LAYOUT_CARDS].map((item, index) => (
                <article
                  lang="ko"
                  className={`${styles.reviewCard} ${item.kind === 'press' ? styles.reviewCardPress : styles.reviewCardUser}`}
                  key={`${item.id}-${index}`}
                  aria-hidden={index >= REVIEW_LAYOUT_CARDS.length ? true : undefined}
                >
                  <div className={styles.reviewHeader}>
                    <div className={styles.reviewAvatar} aria-hidden="true">
                      {item.avatar}
                    </div>
                    <div className={styles.reviewHeaderMeta}>
                      <span>{item.source}</span>
                      <small>{item.authoredAt}</small>
                    </div>
                  </div>
                  <h3>{item.title}</h3>
                  {item.kind === 'user' && <div className={styles.reviewStars} aria-hidden="true">★★★★★</div>}
                  <p>{item.body}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section id="contact" className={styles.stickyFooterSection} aria-labelledby="contact-heading">
        <div className={styles.contactInner}>
          <div className={styles.contactCopy}>
            <p className={styles.contactEyebrow}>{t('contact.eyebrow')}</p>
            <h2 id="contact-heading">{t('contact.heading')}</h2>
            <p className={styles.contactDescription}>{t('contact.description')}</p>
          </div>

          <div className={styles.contactAction}>
            <a href="mailto:love@fanhearts.com" className={styles.contactSubmit}>
              {t('contact.submit')}
            </a>
          </div>
        </div>

        <footer className={styles.footer}>
          <div className={styles.footerLeft}>
            <p className={styles.footerCompany}>FanHearts Co., Ltd. (formerly Peacecover)</p>
            <div className={styles.footerMetaColumn}>
              <p>{t('footer.registration')}</p>
              <p>{t('footer.salesRegistration')}</p>
              <p>{t('footer.address')}</p>
              <p>{t('footer.customerCenter')}: 070-7954-2342</p>
              <p>
                {t('footer.serviceInquiry')}:{' '}
                <a href="mailto:love@fanhearts.com">love@fanhearts.com</a>
              </p>
            </div>
          </div>

          <div className={styles.footerRight}>
            <nav className={styles.footerLanguages} aria-label={t('footer.languages')}>
              {siteLanguages.map(item => <a key={item.code} href={sitePaths[item.code]} hrefLang={item.code} lang={item.code}>{item.label}</a>)}
            </nav>
            <div className={styles.footerPolicyRow}>
              <a href="/terms/?tab=terms_of_service">{t('footer.terms')}</a>
              <span>|</span>
              <a href="/terms/?tab=privacy_policy">{t('footer.privacy')}</a>
            </div>
          </div>
        </footer>
      </section>
    </div>
  )
}
